import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { TranslateService } from '@ngx-translate/core';
import { environment as config } from '../../environments/environment';
import * as store from 'store';

@Injectable()
export class Translation {
  public langs: any;
  public lang: any;
  public countryCode: string;

  constructor(public translate: TranslateService, private http: Http) {
    this.translate.setDefaultLang(config.translations.default);
    this.lang = store.get(config.translations.key);
    this.getLang().subscribe(val => {
      this.langs = val.lang;
      this.lang = this.langs.filter(lang => lang.id === (this.lang ? this.lang : config.translations.default)).shift();
      this.translate.use(this.lang ? this.lang.id : config.translations.default);
    });
    this.translate.onLangChange.subscribe((event: any) => {
      this.lang = this.langs.filter(lang => lang.id === event.lang).shift();
      store.set(config.translations.key, this.lang.id);
      this.translate.get('lang.countryId').subscribe(code => {
        this.countryCode = code;
      });
    });
  }

  private getLang() {
    return this.http.get('../../../assets/lang.json').map(res => res.json());
  }

  public updateLang(tmpLang) {
    const curentLang = this.langs.filter(lang => lang.id === tmpLang).shift();
    this.translate.use(curentLang.id);
  }
}



// WEBPACK FOOTER //
// ./src/app/providers/translation.ts